<template>
  <div class="flex items-start justify-start gap-[12px]">
    <div class="shrink-0 h-[50px] flex items-center justify-center">
      <div class="block size-[42px] bg-[#FFECE9] rounded-full text-[24px] flex items-center justify-center">
        <span
          class="font-semibold text-[#F95031]"
          :class="icon"
        />
      </div>
    </div>
    <div>
      <p class="mb-[8px] text-[12px] text-[#626262]">
        {{ title }}
      </p>
      <p
        class="mb-0 font-semibold text-[14px] text-[#000000]"
        :class="{ 'w-full max-w-[100px] rounded-[10px] animate-pulse bg-[#F4F4F4] h-[20px]': loading}"
      >
        <span v-show="!loading">
          <slot />
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'k-flag',
    },
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
